import React from "react";
import { useTranslation } from "react-i18next";

import { useAppApi } from "@/App";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { PaymentsTable } from "@components/Statistics";
import { url_reverse } from "@components/Utils";

export default function MarketPaymentsScreen() {
    return (
        <DefaultLayout>
            <List />
        </DefaultLayout>
    );
}

function List() {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:market:payment:list"));

    if (!apiData) return;

    return (
        <ListingCard header={t("Платежи")}>
            <PaymentsTable forMarket={true} showRefundButton={true} />
        </ListingCard>
    );
}
